import { with1ezpy3gn0rpui as with_0 } from '../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/party/PartyId.mjs';
import { SavePinMutation3865jhueq4vmv as SavePinMutation } from './schema/SavePinMutation.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Accepted_instancehwhu2w41uegl as Accepted_instance } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/CommandResult.mjs';
import { Dispatcherb76d0p5pxiow as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pin/SavePinCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SavePinInputnc3r3ek8pldn as SavePinInput } from './schema/type/SavePinInput.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *perform(command, $completion) {
  var partyId = command.ze();
  var pin = command.af();
  yield* this.v75(new (SavePinMutation())(savePinInput(with_0(partyId, pin))), $completion);
  return Accepted_instance;
}
var SdkSavePinCommandDispatcherClass;
function SdkSavePinCommandDispatcher() {
  if (SdkSavePinCommandDispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkSavePinCommandDispatcher', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkSavePinCommandDispatcherClass = $;
  }
  return SdkSavePinCommandDispatcherClass;
}
function savePinInput(_this__u8e3s4) {
  return new (SavePinInput())(_this__u8e3s4.n2b_1, _this__u8e3s4.o2b_1.e2e_1, _this__u8e3s4.o2b_1.g2e_1, _this__u8e3s4.o2b_1.f2e_1);
}
//region block: exports
export {
  SdkSavePinCommandDispatcher as SdkSavePinCommandDispatcher1w2xmq7bhdmfl,
  perform as perform3pf84jpgzmm3h,
};
//endregion

//# sourceMappingURL=SdkSavePinCommandDispatcher.mjs.map
